import React, { Component } from "react";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";

import TablePaginationAction from "../TablePaginationAction/TablePaginationAction";

class CustomTableFooter extends Component {
  render() {
    return (
      <TableFooter>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[
              5,
              10,
              20,
              30,
              40,
              50,
              { label: "All", value: -1 },
            ]}
            count={this.props.count}
            rowsPerPage={this.props.rowsPerPage}
            page={this.props.page}
            onChangePage={this.props.onChangePage}
            onChangeRowsPerPage={this.props.onChangeRowsPerPage}
            ActionsComponent={TablePaginationAction}
          />
        </TableRow>
      </TableFooter>
    );
  }
}

export default CustomTableFooter;
